import React, { useState, useRef } from 'react';
import { noop } from 'lodash';
import { string, func } from 'prop-types';
import { I18n, I18nProvider, Experiment, Variant, Control } from '@fiverr-private/fiverr_context';
import { bigQuery } from '@fiverr-private/obs';
import { QUALAS_USER_PAGE_LOYALTY_BANNER } from '../../../../experiments/experimentsEnum';
import useObserver from './useObserver';
import EducationIcon from './EducationIcon';
import { TROPHY_GIF_PATH } from './assets';
import { loyaltyBigQueryParams } from './utils';

import './style.scss';

const LoyaltySellerBanner = ({ sellerId, sellerName, handleLoyaltyBannerView = noop }) => {
    const [observerd, setObserverd] = useState(false);
    const loyaltyRef = useRef(null);

    const onObserve = () => {
        if (!observerd) {
            handleLoyaltyBannerView();
            bigQuery.send(loyaltyBigQueryParams({ sellerId, sellerName }));
            setObserverd(true);
        }
    };

    useObserver({
        observableRef: loyaltyRef,
        onObserve
    });

    return (
        <Experiment test={QUALAS_USER_PAGE_LOYALTY_BANNER}>
            <Control>
                <span ref={loyaltyRef}/>
            </Control>
            <Variant v={2}>
                <div className="seller-loyalty-banner">
                    <I18nProvider>
                        {({ i18n }) => <img src={TROPHY_GIF_PATH} alt={i18n.t('user_page_perseus.loyalty_seller.banner.alt')}/>}
                    </I18nProvider>
                    <span className="seller-loyalty-title" ref={loyaltyRef}>
                        <div className="seller-loyalty-title-main">
                            <I18n k={'user_page_perseus.loyalty_seller.banner.title'} parseMarkup={true}/>&nbsp;<EducationIcon sellerId={sellerId} sellerName={sellerName}/>
                        </div><br/>
                        <I18n k={'user_page_perseus.loyalty_seller.banner.description'} params={{ sellerName }} parseMarkup={true}/>
                    </span>
                </div>
            </Variant>
        </Experiment>
    );
};

LoyaltySellerBanner.propTypes = {
    sellerName: string.isRequired,
    handleLoyaltyBannerView: func
};

export default LoyaltySellerBanner;
